import ReactGA from 'react-ga';

/**
 * 
 */
class Analytics {
  /**
   * @param {Array} gaTrackingIds
   */
  static init(gaTrackingIds) {
    const gaTrackerName = window.locatorTenancy.gaTrackerName;
    const googleAnalyticsIdUA = gaTrackingIds[0];
    const googleAnalyticsIdGA4 = gaTrackingIds[1];
    const options = {};

    if (gaTrackerName) {
      options.gaOptions = { name: gaTrackerName };
    }

    ReactGA.initialize([
      {
        googleAnalyticsIdUA,
        options
      },
      {
        googleAnalyticsIdGA4,
        options
      }
    ]);
  }

  /**
   * 
   * @param {String} trackingId 
   */
  static appendGoogleAnalyticsScript(trackingId) {
    const script = document.createElement('script');
    script.async = true;
    script.id = 'ga-script';
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    document.head.appendChild(script);
  }

  /**
   * 
   * @param {String} trackingId 
   */
  static appendGoogleAnalyticsV4Script(trackingId) {
    const script = document.createElement('script');
    script.async = true;
    script.id = 'ga4-script';
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', trackingId);
    };
    document.head.appendChild(script);
  }

  static appendAdobeAnalyticsScript() {
    const jqueryScript = document.getElementById('jquery-script');

    if (!jqueryScript) {
      const script = document.createElement('script');
      script.src = 'https://code.jquery.com/jquery-3.6.1.min.js';
      script.id = 'jquery';
      document.head.appendChild(script);
    }

    const aaScript = document.createElement('script');
    const env = process.env.NODE_ENV === 'production' ? 'prod' : 'qa';

    aaScript.type = 'text/javascript';
    aaScript.src = `https://tags.tiqcdn.com/utag/luxottica/essilor/${env}/utag.js?v=${new Date().valueOf()}`;
    aaScript.id = 'adobe-analytics-script';
    document.head.appendChild(aaScript);
  }
}

export default Analytics;
